import { useState } from "react";
import { Link } from "react-router-dom";
import { api, formatApiErrorDetail } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [token, setToken] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const { data } = await api.post("/auth/forgot-password", { email });
      setToken(data.reset_token || "");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || "Request failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-zinc-50 px-4">
      <div className="w-full max-w-sm">
        <Link to="/" className="mb-8 flex justify-center">
          <img src="/kk-logo.png" alt="KK Beauty & Fashion" className="h-12 w-auto max-w-full" />
        </Link>
        <div className="border border-zinc-200 bg-white p-8">
          <h1 className="font-display text-lg">Reset Password</h1>
          {!token ? (
            <form onSubmit={submit} className="mt-6 space-y-5">
              <p className="text-sm text-zinc-500">Enter your admin email to generate a reset token.</p>
              <div>
                <Label className="text-xs uppercase tracking-wider text-zinc-500">Email</Label>
                <Input type="email" value={email} onChange={(e) => setEmail(e.target.value)} className="mt-1.5 rounded-none border-zinc-300" required data-testid="forgot-email" />
              </div>
              {error && <p className="text-sm text-kksale">{error}</p>}
              <Button type="submit" disabled={loading} className="h-11 w-full rounded-none bg-zinc-900 text-xs uppercase tracking-widest" data-testid="forgot-submit">
                {loading ? "Generating…" : "Generate Reset Token"}
              </Button>
            </form>
          ) : (
            <div className="mt-6 space-y-4" data-testid="forgot-success">
              <p className="text-sm text-zinc-600">A reset token has been generated. Use it to set a new password.</p>
              <div className="break-all border border-zinc-200 bg-zinc-50 p-3 text-xs text-zinc-700">{token}</div>
              <Link
                to={`/admin/reset-password?token=${token}`}
                className="flex h-11 w-full items-center justify-center rounded-none bg-zinc-900 text-xs uppercase tracking-widest text-white hover:bg-zinc-800"
                data-testid="goto-reset"
              >
                Continue to Reset
              </Link>
            </div>
          )}
          <Link to="/admin/login" className="mt-4 block text-center text-xs text-zinc-500 hover:text-zinc-900">
            Back to login
          </Link>
        </div>
      </div>
    </div>
  );
}
